import { ChangeDetectorRef, Component, OnChanges, OnInit } from '@angular/core';
import { CoreLogService } from '../../services/log.service';
import { environment } from '../../../../environments/environment';
import { BannerService } from './banner.service';
import { WebShopService } from '../../services/webShop.service';

@Component({
  selector: 'banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})

export class BannerComponent implements OnInit {
  public visible: boolean = false;
  public link: string = '';

  constructor(public bannerState: BannerService
    , private _coreLogService: CoreLogService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _webshopService: WebShopService
  ) { }

  ngOnInit(): void {
    this.visible = this.bannerState.visible;
    this.link = this.bannerState.link;
    this.PushChanges();
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("banner.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  /** Redirect to the app or store */
  public redirectToApp() {
    const me = this;
    const target = `${environment.IntentScheme}://${me.link}`;
    try {
      window.open(target, "_self");
      setTimeout(() => {
        window.location.replace(environment.storeURL.AppleStore);
      }, 2000);
    } catch (e) {
      this._coreLogService.error(
        "BannerComponent.openApp",
        "window.open, open application",
        e
      );
    }
  }

  /** close banner */
  public close() {
    const me = this;
    me.visible = !me.visible;
    me.PushChanges();
  }

}